import { useMenuContext } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import { useLayoutEffect, useMemo, useState } from 'react';
export function useMenuHeaderRegistry() {
    const [header, setHeader] = useState(null);
    const registry = useMemo(() => ({ setContent: setHeader }), []);
    return { header, registry };
}
export function useMenuHeaderRegistration(content) {
    const headerRegistry = useMenuContext()?.headerRegistry;
    useLayoutEffect(() => {
        headerRegistry?.setContent(content);
        return () => headerRegistry?.setContent(null);
    }, [content, headerRegistry]);
}
//# sourceMappingURL=useMenuHeaderRegistry.js.map